import React from 'react';
import useMetaTags from '../../hooks/useMetaTags';
import Boost_section from "../../component/Services_Component/Boost_section";
import Assistance_section from "../../component/Services_Component/Assistance_section";
import FAQ_section from "../../component/Services_Component/FAQ_section";
import Role_writing from "../../component/Services_Component/Role_writing";
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";
import {
  AssistanceSection,
  BoostSection,
  FAQ,
  roleWriting,
  LargeData
} from "../../Data/All_Services_Data/dataManagementData";

const DataManagement = () => {
    useMetaTags({
      title: "Comprehensive Data Management Services for Your Business",
      description:
        "Optimize your business with our data management services.Get reliable solutions to organize, analyze, and manage your data effectively",
      keywords:
        "data management services, data management, database management, data management system, master data management, data management platform, data management consultant, data management solution, data asset management",
    });
    return (
      <>
        <section
          className=""
          style={{
            backgroundImage: `url('assets/img/service/serviceD.jpg')`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          id="service-sec"
        >
          <div className="round-container pt-5">
            <div className="container">
              <div className="title-area text-center">
                <span className="sub-title text-white">OUR SERVICES</span>
                <h1 className="sec-title text-white">
                  Data Management Services
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="space-extra-bottom">
          <div className="page-single">
            <div className="page-content">
              <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
              {/* Intro part  */}
              <div
                className="header-section container"
                style={{ marginTop: "20px" }}
              >
                <img
                  src="assets/img/icon/data-manage.avif"
                  loading="lazy"
                  alt="heading_image"
                />
                <p>
                  In the core of what we do is the implementation of effective
                  data management at scale. We offer full spectrum data
                  management services which we tailor to your unique business
                  requirements. We see to it that your data is accurate,
                  available when you need it, secure against threats, and easy
                  to use which in turn empowers your organization to make
                  informed decisions with confidence. We take a total picture
                  approach which includes transformation, integration, security
                  and governance. Whether you are working with big data, legacy
                  systems, or cloud platforms we have the expertise to support
                  your data journey. Count on us to transform your data into a
                  strategic asset that fuels innovation and growth. We have
                  recognized the power of data which is at the core of decision
                  making across all sectors. In the age of digital
                  transformation which is very quick, businesses require
                  reliable partners to manage their data well. Our data
                  management services are designed to support companies with
                  their data complexities which may be hard to handle. From
                  improving data quality to help with regulatory compliance we
                  work to improve every aspect of your data life cycle. We not
                  only put in place measures which reduce risk but also bring to
                  light that which is hidden in your data. We will guide you in
                  your data management journey with our expertise and the right
                  tools for your long term success.
                </p>
              </div>

              {/* End to End data management Services  */}
              <Handle_Largedata_section LargeData={LargeData} />

              {/* Trust Us  */}
              <Role_writing data={roleWriting} />

              {/*Trusted and Fast Data Management Solutions  */}
              <Boost_section data={BoostSection} />

              {/* Hire Data Management Services?  */}
              <Assistance_section data={AssistanceSection} />

              {/* FAQ section  */}
              <FAQ_section data={FAQ} />
            </div>
          </div>
        </section>
        <div className="scroll-top">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              style={{
                transition: "stroke-dashoffset 10ms linear 0s",
                strokeDasharray: "307.919, 307.919",
                strokeDashoffset: "307.919",
              }}
            ></path>
          </svg>
        </div>
      </>
    );
};

export default DataManagement;